import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useDeleteQuestion(data = {}) {
  const { quizID, courseID, chapterID } = data ?? {};
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function deleteQuizQuestion(questionID) {
    return privateFetch.delete(
      `/v1/admin/course/${courseID}/chapters/${chapterID}/quizzes/${quizID}/questions/${questionID}`
    );
  }

  function manageQuizQuestion(data = {}) {
    return deleteQuizQuestion(data.id);
  }

  return useMutation(manageQuizQuestion, {
    onSuccess() {},
    onSettled() {
      queryClient.invalidateQueries(['quiz-questions', quizID]);
    },
  });
}

export default useDeleteQuestion;
